<template>
    <section v-if="parseFloat(data.selectedFanData.moment_of_inertia)" class="engine-start-time">
        <h2 v-html="translate('engine-start-time-title')"/>

        <div class="engine-start-time-container" v-if="!workOnInverter">
            <div class="engine-start-time-container">
                <div class="engine-start-time-data">
                    <div class="container">
                        <div class="element" v-for="item in getStartTimeData().left" :key="item.title">
                            <span class="title">{{ translate(item.title) }}</span>
                            <span class="value" v-html="item.value"></span>
                        </div>
                    </div>
                    <div class="container">
                        <div class="element" v-for="item in getStartTimeData().right" :key="item.title">
                            <span class="title">{{ translate(item.title) }}</span>
                            <span class="value" v-html="item.value"></span>
                        </div>
                    </div>
                </div>
                <div class="start-possible">
                    <div class="container">
                        <div class="element" v-for="item in getStartPossibleData()" :key="item.title">
                            <span class="title" v-html="item.title"></span>
                            <span class="value" v-html="item.value"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- NVS-81 -->
        <div class="work-on-inverter" v-else v-text="translate('work_on_the_inverter') + '. ' + translate('resonant_frequency_check')"></div>

    </section>
</template>

<script>
    export default {
        name: "engineStartTime",
        props: ['data'],
        methods: {
            getStartTimeData() {
                return {
                    left: [
                        { title: "rotor_moment_of_inertia", value: `${this.round(this.data.params.start_time.rotor_moment_of_inertia, 3)} [kgm<sup>2</sup>]`},
                        { title: "torque_tn", value: `${this.round(this.data.params.start_time.torque_tn, 1)} [Nm]` },
                        { title: "moment_delta", value: `${this.round(this.data.params.start_time.moment_delta, 1)} [Nm]` },
                        { title: "moment_y", value: `${this.round(this.data.params.start_time.moment_y, 1)} [Nm]` },
                        { title: "avg_mow", value: `${this.round(this.data.params.start_time.avg_mow, 1)} [Nm]` },
                        { title: "avg_mowz", value: `${this.round(this.data.params.start_time.avg_mowz, 1)} [Nm]` },
                        { title: "moment_j", value: `${this.round(this.data.params.start_time.moment_j, 3)} [kgm<sup>2</sup>]` }
                    ],
                    right: [
                        { title: "t_delta", value: `${this.round(this.data.params.start_time.t_delta, 1)} [s]` },
                        { title: "t_deltaz", value: `${this.round(this.data.params.start_time.t_deltaz, 1)} [s]` },
                        { title: "t_y", value: `${this.round(this.data.params.start_time.t_y, 1)} [s]` },
                        { title: "t_yz", value: `${this.round(this.data.params.start_time.t_yz, 1)} [s]` }
                    ]
                }
            },

            getStartPossibleData() {
                return this.data.params.start_time.possible.map(elem => {return {title: elem.title, value: elem.value.split('|').map(v => this.translate(v)).join(', ')}});
            },

            getSelectedElementOfOption(elements) {
                for (let elementId in elements) {
                    if (elements.hasOwnProperty(elementId) && elements[elementId].active == true)
                        return elements[elementId].value;
                }

                return null;
            },

            round(num, dec) {
                return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
            },

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            getVariable(code) {
                let arg = {
                    type: 'getVariable',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);
                if (arg.out === '' || null) {
                    return {variableTranslation: code, variableDefaultKey: 0, variableValues: []};
                }
                return arg.out;
            },
        },
        computed: {
            workOnInverter() {
                let net_f = (this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements[1].active) ? 60 : 50
                if (this.$store.state.workPointParameters.elements.work_frequency.value != net_f) return true
                return this.$store.state.fourthStepParametersSelected.work_on_the_inverter.options[0].elements[1].active
            }
        }
    }
</script>